(() => {
  const names = {
    "A Ii Elite": "A II Elite",
    "A Ii Pro": "A II Pro",
    "A Ii Select": "A II Select",
    "Morelia Ii Japan": "Morelia II Japan",
    "Morelia Neo Iv Pro Ag": "Morelia Neo IV Pro Ag",
    "Alpha Ii Pro As": "Alpha II Pro As",
    "Pro 245 Golf Iron Set": "Mizuno Pro 245 Golf Iron Set",
    "Jpx925 Hot Metal Hl Golf Iron Set": "JPX925 Hot Metal Hl Golf Iron Set",
    "Pro T-1 Black Ion": "Mizuno Pro T-1 Black Ion",
    "Pro Stand Golf Bag": "Mizuno Pro Stand Golf Bag",
    "Monarcida Neo Iii Select": "Monarcida Neo III Select",
    "Morelia Neo Iv Pro As": "Morelia Neo IV Pro As",
    "Jpx925 Hot Metal Pro Gs -7Pc #4-Pw": "JPX925 Hot Metal Pro Gs -7Pc #4-Pw",
    "Jpx925 Hot Metal High Launch F1 -7Pc #5-Gw Ladies": "JPX925 Hot Metal High Launch F1 -7Pc #5-Gw Ladies",
    "Jpx925 Hot Metal High Launch F1 - 8Pc #5-Sw Ladies": "JPX925 Hot Metal High Launch F1 - 8Pc #5-Sw Ladies",
    "Jpx925 Forged Graphite St- 7Pc #4-Pw": "JPX925 Forged Graphite St- 7Pc #4-Pw",
    "Jpx925 Forged Black Steel-7Pc": "JPX925 Forged Black Steel-7Pc",
    "Pro S3 Steel- 7Pc #4-Pw": "Mizuno Pro S3 Steel- 7Pc #4-Pw",
    "Pro T-1 White Satin": "Mizuno Pro T-1 White Satin",
    "Pro T-1 Blue Ion": "Mizuno Pro T-1 Blue Ion",
    "Pro T-3 White Satin": "Mizuno Pro T-3 White Satin",
    "Pro T-1 Denim Copper": "Mizuno Pro T-1 Denim Copper",
    "Pro T-3 Black Ion": "Mizuno Pro T-3 Black Ion",
    "Pro S-1 Irons - 7Pc #4-Pw": "Mizuno Pro S-1 Irons - 7Pc #4-Pw",
    "Pro M-15 Irons - 8Pc #4Gw": "Mizuno Pro M-15 Irons - 8Pc #4Gw",
    "Jpx One Driver Helium Ladies": "JPX One Driver Helium Ladies",
    "Jpx One Driver Dn Frst Blue": "JPX One Driver Dn Frst Blue",
    "Jpx One Driver Tensei Blue": "JPX One Driver Tensei Blue",
    "Jpx One Fairway Helium Ladies": "JPX One Fairway Helium Ladies",
    "Jpx One Fairway Dn Frst Blue": "JPX One Fairway Dn Frst Blue",
    "Jpx One Fairway Tensei": "JPX One Fairway Tensei",
    "Jpx One Hybrid Helium  Ladies": "JPX One Hybrid Helium  Ladies",
    "Jpx One Hybrid Denali Frost Blue": "JPX One Hybrid Denali Frost Blue",
    "Jpx One Hybrid Blue": "JPX One Hybrid Blue",
    "Jpx One Hybrid Tensei": "JPX One Hybrid Tensei",
    "Jpx Golf Glove": "JPX Golf Glove",
    "Pro S Golf Ball": "Mizuno Pro S Golf Ball",
    "Pro X Golf Ball": "Mizuno Pro X Golf Ball",
    "Morelia Neo Iv Elite": "Morelia Neo IV Elite",
    "Morelia Neo Iv Beta Elite": "Morelia Neo IV Beta Elite",
    "Morelia Neo Iv Pro": "Morelia Neo IV Pro",
    "Alpha Iii Pro": "Alpha III Pro",
    "Alpha Iii Elite": "Alpha III Elite",
    "Alpha Iii Select": "Alpha III Select",
    "Alpha Iii Jf Japan": "Alpha III Jf Japan"
  };
  const ignored = 'script,style,textarea,input,select';

  function fixText(node) {
    const key = node.nodeValue.trim();
    if (Object.prototype.hasOwnProperty.call(names, key)) {
      node.nodeValue = node.nodeValue.replace(key, names[key]);
    }
  }

  function fix(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      fixText(root);
      return;
    }
    // Reject excluded subtrees once instead of checking closest() for every text node.
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            return node.matches(ignored) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_SKIP;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );
    while (walker.nextNode()) fixText(walker.currentNode);
  }

  function init() {
    fix(document.body);
    const pending = new Set();
    let queued = false;

    function flush() {
      queued = false;
      for (const root of pending) {
        if (!root.isConnected) continue;
        // A parent queued in the same batch will already visit this node.
        let parent = root.parentNode;
        while (parent && !pending.has(parent)) parent = parent.parentNode;
        if (!parent && !root.parentElement?.closest(ignored)) fix(root);
      }
      pending.clear();
    }

    function queue(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        // Ignore our own corrections and unrelated text changes (prices, clocks, etc.).
        if (!Object.prototype.hasOwnProperty.call(names, node.nodeValue.trim())) return;
      } else if (node.nodeType !== Node.ELEMENT_NODE || node.matches(ignored)) {
        return;
      }
      pending.add(node);
    }

    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') queue(record.target);
        else for (const node of record.addedNodes) queue(node);
      }
      if (pending.size && !queued) {
        queued = true;
        requestAnimationFrame(flush);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
